<template>
    <div class="form-item">
        <p class="item-title" v-if="itemLabel">{{ itemLabel }}</p>
        <slot></slot>
    </div>
</template>
<script>
export default {
    props: {
        itemLabel: {
            type: String,
            default: ''
        }
    }
}
</script>
<style lang="less" scoped>
    .form-item {
        margin-bottom: 10px;
        .item-title {
            margin: 0;
            color: #878787;
            font-size: 14px;
            line-height: 30px;
        }
    }
</style>
